module.exports = __webpack_public_path__ + "static/media/transdigitalLogoWhite@2x.822f1478.png";